import { FeatureFlagType } from '~/enums/FeatureFlagType';
import { testHasFlag } from '~/permissions/utils/testHasFlag';

import { useCurrentUser } from './useCurrentUser';

export const useHasFeatureFlag = (featureFlag: FeatureFlagType): boolean => {
  const user = useCurrentUser();
  return testHasFlag(featureFlag)(user);
};
